export const CAN_USE_DOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
export const DEFAULT_IMAGE = 'https://img.mako.co.il/2023/10/15/placeholder-pic.png';
export const CANDLES_AMOUNT_LS_KEY = 'candlesAmount';
export const PERSONS_CANDLES_LS_KEY = 'personsCandles';
